// WhatsApp templates (decision 14): once 24 hours have passed since the member's last message, only a
// template Meta approved can go. Ops pick one, fill in its values ({{1}} is the member's first name),
// and send it through the same approval; the member's next reply opens the window again.
import { useEffect, useState } from "react";

import { api } from "./api";
import type { Template } from "./types";

export type Chosen = { name: string; params: string[] };

const render = (body: string, params: string[]) => body.replace(/\{\{(\d+)\}\}/g, (_, n) => params[Number(n) - 1] || `{{${n}}}`);

export function TemplatePicker({ member, busy, onSend }: { member: string; busy: boolean; onSend: (chosen: Chosen) => void }) {
  const [templates, setTemplates] = useState<Template[] | null>(null);
  const [name, setName] = useState("");
  const [params, setParams] = useState<string[]>([]);

  useEffect(() => {
    api<Template[]>("/api/templates")
      .then(setTemplates)
      .catch(() => setTemplates([]));
  }, []);

  const pick = (chosen: string) => {
    const t = templates?.find((x) => x.name === chosen);
    setName(chosen);
    setParams(t ? Array.from({ length: t.params }, (_, i) => (i === 0 ? member.split(" ")[0] ?? "" : "")) : []);
  };

  if (templates === null) {
    return <p className="muted">Loading templates…</p>;
  }
  if (templates.length === 0) {
    return <p className="note warn">No template is approved yet, so nothing can go until the member writes again (Settings, WhatsApp templates).</p>;
  }
  const template = templates.find((t) => t.name === name);
  return (
    <div className="templates">
      <select value={name} onChange={(e) => pick(e.target.value)}>
        <option value="">Choose a template</option>
        {templates.map((t) => (
          <option key={t.name} value={t.name}>
            {t.name}
          </option>
        ))}
      </select>
      {template &&
        params.map((value, i) => (
          <input
            key={i}
            placeholder={i === 0 ? "{{1}}: the member's first name" : `{{${i + 1}}}`}
            value={value}
            onChange={(e) => setParams(params.map((p, j) => (j === i ? e.target.value : p)))}
          />
        ))}
      {template && <p className="preview">{render(template.body, params)}</p>}
      <button disabled={busy || !template || params.some((p) => !p.trim())} onClick={() => onSend({ name, params })}>
        Send this template
      </button>
    </div>
  );
}
